import { render, staticRenderFns } from "./dashboardPage.vue?vue&type=template&id=0c52e473&"
import script from "./dashboardPage.vue?vue&type=script&lang=js&"
export * from "./dashboardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports